const Types = {
  SAVE_USER_DATA: 'SAVE_USER_DATA',
  CLEAR_USER_DATA: 'CLEAR_USER_DATA',
  REFRESH_PROFILE: 'REFRESH_PROFILE',

  UPDATE_AUTH_DATA: 'UPDATE_AUTH_DATA',
  UPDATED_AUTH: 'UPDATED_AUTH',

}

export default Types
